"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventBusSynchronizedCacheInformant = void 0;
const types_1 = require("./types");
const utils_1 = require("./utils");
const core_1 = require("../../core");
class EventBusSynchronizedCacheInformant {
    constructor(cacheName, eventBus) {
        this.eventBus = eventBus;
        this.cacheName = cacheName;
    }
    cleanCache() {
        this.eventBus.publish((0, utils_1.getEventName)(this.cacheName, types_1.TypeEventMap.CLEAR.toString()), new types_1.ClearCacheEvent());
        core_1.Log.info(`[EventBusSynchronizedCacheInformant] ${this.cacheName}: Event CLEAR published`);
    }
    removeCached(key) {
        this.eventBus.publish((0, utils_1.getEventName)(this.cacheName, types_1.TypeEventMap.REMOVE.toString()), new types_1.RemoveItemCacheEvent({ key }));
        core_1.Log.info(`[EventBusSynchronizedCacheInformant] ${this.cacheName}: Event REMOVE published`);
    }
    setCached(key, result, cacheLiveTime) {
        this.eventBus.publish((0, utils_1.getEventName)(this.cacheName, types_1.TypeEventMap.SET.toString()), new types_1.SetItemCacheEvent({
            key,
            result,
            cacheLiveTime,
        }));
        core_1.Log.info(`[EventBusSynchronizedCacheInformant] ${this.cacheName}: Event SET published`);
    }
    getCached(key) {
        throw new Error('You shouldn`t execute this method in the informant.');
    }
}
exports.EventBusSynchronizedCacheInformant = EventBusSynchronizedCacheInformant;
//# sourceMappingURL=informant.js.map